import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { IApplicationState, IAppState } from "@nkr/store/index";
import { Panel, Button, FormControl } from "react-bootstrap";
import { LoadingIndicator } from "../loading-indicator";
import MediaQuery from "react-responsive";

enum Account {
    CenterAccount = 1,
    CoachAccount = 2,
    DonorConnectAccount = 3,
    IldaAccount = 4
}

interface IOwnProps extends RouteComponentProps<{}> { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps { }

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    showLoading: boolean,
    isDonorConnect: boolean,
    selectedAccount: Account
}

const initialState: IState = {
    showLoading: false,
    isDonorConnect: false,
    selectedAccount: null
};

class SelectAccount extends React.Component<TProps, IState> {
    readonly state: IState = initialState;

    componentDidMount = () => {
        let isDonorConnect = this.props.app.user.group.isNkdo == true;
        let selectedAccount = Account.CenterAccount;

        if (isDonorConnect) {
            selectedAccount = Account.DonorConnectAccount;
        }

        this.setState({
            isDonorConnect,
            selectedAccount
        });
    }

    handleAccountChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            selectedAccount: parseInt(e.currentTarget.value)
        });
    }

    handleContinue = () => {
        this.setState({
            showLoading: true
        }, () => {
            if (this.state.selectedAccount == Account.CenterAccount) {
                window.location.href = '/center/' + this.props.app.user.centerId;
            }

            if (this.state.selectedAccount == Account.CoachAccount) {
                window.location.href = '/microsite/coach';
            }

            if (this.state.selectedAccount == Account.DonorConnectAccount) {
                window.location.href = '/donor-connect/to-do';
            }

            if (this.state.selectedAccount == Account.IldaAccount) {
                window.location.href = '/ilda/to-do';
            }
        });
    }

    render = () => {
        return (
            <div className="container-fluid">
                <LoadingIndicator
                    type="spin"
                    color="black"
                    loading={this.state.showLoading}
                    message={"One moment please..."}
                />

                <MediaQuery minWidth={1025}>
                    {(matches) => {
                        const width = matches ? "30%" : "90%";

                        return (
                            <div style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0, margin: "auto", width, height: "50%" }}>
                                <Panel>
                                    <Panel.Heading>Account Selection</Panel.Heading>
                                    <Panel.Body>
                                        <div style={{ marginBottom: 20 }}>To continue, please select the account you want to access...</div>
                                        <div style={{ minHeight: 150 }}>
                                            <FormControl
                                                componentClass='select'
                                                style={{ width: 'initial' }}
                                                value={this.state.selectedAccount}
                                                onChange={this.handleAccountChange}
                                            >
                                                {this.state.isDonorConnect == false ?
                                                    <>
                                                        <option value={Account.CenterAccount}>Your Center Account</option>
                                                        <option value={Account.CoachAccount}>Your Microsite Coach Account</option>
                                                    </>
                                                    :
                                                    <>
                                                        <option value={Account.DonorConnectAccount}>Donor Mentor Account</option>
                                                        <option value={Account.IldaAccount}>ILDA Account</option>
                                                    </>
                                                }
                                            </FormControl>
                                        </div>
                                    </Panel.Body>
                                    <Panel.Footer>
                                        <Button bsStyle="primary" onClick={this.handleContinue}>Continue...</Button>
                                    </Panel.Footer>
                                </Panel>
                            </div>
                        );
                    }}
                </MediaQuery>
            </div>
        )
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {};
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SelectAccount);
